import "antd/es/input/style";
import _Input from "antd/es/input";
import hoistNonReactStatics from 'hoist-non-react-statics';
import InputWithCounter from './InputWithCounter';
import Input from './Input';
import InputGroup from './InputGroup';
import Password from './Password';
import TextArea from './TextArea';
import Search from './Search';
import './index.less';
var OSUIInput = Input;
hoistNonReactStatics(OSUIInput, _Input);
OSUIInput.Password = Password;
OSUIInput.TextArea = TextArea;
OSUIInput.Group = InputGroup;
OSUIInput.Search = Search;
OSUIInput.InputWithCounter = InputWithCounter;
export default OSUIInput;
//# sourceMappingURL=index.js.map